(function($) {
  var A104_CHAR_MAX = 40;
  var A104_SYMBOL_COST = 3;
  var A104_ALLOWED_FONTS = ['G02', 'G04', 'G05', 'G06'];
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var previewSideCount = 1;
  var physicalSideMap = [0];
  var globalFont = null;
  var fontsCache = null;
  var symbolsCache = null;

  var A104_PREVIEW_IMAGES = {
    silver: window.VIV_A104.bild_a104_preview_silver_png,
    gold: window.VIV_A104.bild_a104_preview_gold_png,
    rosegold: window.VIV_A104.bild_a104_preview_rosegold_png
  };

  /* ---- Motive: W-Reihe (2026-08-07) --------------------------------------
     Loest die alte C-Reihe ab — Beschluss Yin: eine einzige Icon-Familie im
     ganzen Shop, Referenz ist KE008. Satz = KE008s zehn + Pfote (W31) = elf.
     ★ Bestand kommt jetzt aus DIESER Datei statt aus dem Template-Picker.
     ⚠️ Dateinamen unregelmaessig: w01–w10 zweistellig, ab W11 dreistellig. */
  var A104_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz', 'w02.png': 'Herz', 'w03.png': 'Doppelherz', 'w05.png': 'Infinity',
    'w06.png': 'Jesusfisch', 'w07.png': 'Kreuz', 'w09.png': 'Engel', 'w027.png': 'Anker',
    'w031.png': 'Pfote', 'w036.png': 'Fee', 'w041.png': 'Stern'
  };

  var A104_SYMBOLS_FIXED = [
    { code: 'W01', text: 'Mini Herz',  image: window.VIV_A104.bild_w01_png },
    { code: 'W02', text: 'Herz',       image: window.VIV_A104.bild_w02_png },
    { code: 'W03', text: 'Doppelherz', image: window.VIV_A104.bild_w03_png },
    { code: 'W05', text: 'Infinity',   image: window.VIV_A104.bild_w05_png },
    { code: 'W06', text: 'Jesusfisch', image: window.VIV_A104.bild_w06_png },
    { code: 'W07', text: 'Kreuz',      image: window.VIV_A104.bild_w07_png },
    { code: 'W09', text: 'Engel',      image: window.VIV_A104.bild_w09_png },
    { code: 'W27', text: 'Anker',      image: window.VIV_A104.bild_w027_png },
    { code: 'W31', text: 'Pfote',      image: window.VIV_A104.bild_w031_png },
    { code: 'W36', text: 'Fee',        image: window.VIV_A104.bild_w036_png },
    { code: 'W41', text: 'Stern',      image: window.VIV_A104.bild_w041_png }
  ];

  /* Einzige echte Umbenennung beim Wechsel C → W. */
  var A104_SYMBOL_ALIAS = { 'Fisch': 'Jesusfisch', 'Christenfisch': 'Jesusfisch' };

  function resolveSymbolName(name) {
    name = String(name || '').trim();
    return A104_SYMBOL_ALIAS[name] || name;
  }

  /* =========================================================================
     TUNER-DRIVEN CONFIG — the preview render reads ONLY these variables.
     Every knob is an independent coordinate: text anchor per side, text
     adjustment per [side][font], icon override per [symbol slug].
     Calibrate via ?a104tuner=1 and paste the exported JSON back here.
     ========================================================================= */
  /* Engraving anchor — % of stage, per [side][font]: every font sits
     differently on the band, so each font has its own anchor. Missing font
     -> A104_TEXT_POS_BASE, never another font's anchor. (A104 is sold
     front-only; the back entries only exist so a beidseitig variant would
     not share knobs.) */
  var A104_TEXT_POS_BASE = { x: 50, y: 60.5 };
  var A104_TEXT_POS = {
    "front": {
      "G02": {
        "x": 49,
        "y": 59.5
      },
      "G04": {
        "x": 49,
        "y": 60
      },
      "G05": {
        "x": 49,
        "y": 60
      },
      "G06": {
        "x": 48.5,
        "y": 60
      }
    },
    "back": {
      "G02": {
        "x": 50,
        "y": 60.5
      },
      "G04": {
        "x": 50,
        "y": 60.5
      },
      "G05": {
        "x": 50,
        "y": 60.5
      },
      "G06": {
        "x": 50,
        "y": 60.5
      }
    }
  };
  /* Base text size in cqw (% of stage width). */
  var A104_TEXT_BASE_SIZE = 3.2;
  /* Neutral max-width base, % of stage width — per-[side][font] override via
     TEXT_ADJ.wmax (missing wmax -> this base, never another font's value). */
  var A104_TEXT_MAX_WIDTH_PCT = 58;
  /* Neutral max-HEIGHT base, % of stage (0 = no cap) — tall fonts/icons that
     exceed it shrink the whole line. Per-[side][font] override via
     TEXT_ADJ.hmax (missing hmax -> this base, never another font's value). */
  var A104_TEXT_MAX_HEIGHT_PCT = 4.5;
  /* Per-[side][font] adjustment — size multiplier + own max width (wmax).
     Position lives in A104_TEXT_POS[side][font] (per-font anchor). */
  var A104_TEXT_ADJ = {
    "front": {
      "G02": {
        "mult": 2,
        "wmax": 58
      },
      "G04": {
        "mult": 2
      },
      "G05": {
        "mult": 2
      },
      "G06": {
        "mult": 2
      }
    },
    "back": {
      "G02": {
        "mult": 1
      },
      "G04": {
        "mult": 1
      },
      "G05": {
        "mult": 1
      },
      "G06": {
        "mult": 1
      }
    }
  };
  /* Inline symbol base geometry, em relative to the text size (neutral default).
     height=size, top=up/down, gap=kerning spacing, dx=pure left/right nudge
     (visual only, does not shift following glyphs), rot=own rotation angle. */
  var A104_ICON = {
    "height": 1,
    "top": 0,
    "gap": 0,
    "dx": 0,
    "rot": 0
  };
  /* Per-[font][symbol slug] overrides: { height, top, gap, dx, rot, opacity }.
     Every font pairs with the icons differently, so each (font, symbol)
     combination is its own independent coordinate — size, up/down, left/right,
     angle and opacity all separate. Missing key/property -> falls back to
     A104_ICON / A104_ENGRAVE.iconOpacity, never to another font's or another
     symbol's values. */
  var A104_ICON_ADJ = {
    "G02": {
      "herz": {
        "top": -0.1,
        "height": 1
      },
      "mini-herz": {
        "opacity": 0.45,
        "height": 1,
        "top": -0.1
      },
      "infinity": {
        "height": 1.05,
        "top": 0,
        "dx": 0,
        "gap": 0.25
      },
      "doppelherz": {
        "gap": 0.25,
        "top": -0.1
      },
      "jesusfisch": {
        "dx": 0.25,
        "top": -0.05
      },
      "pfote": {
        "top": -0.05,
        "dx": 0,
        "height": 1.1
      },
      "anker": {
        "top": -0.05,
        "opacity": 0.45
      }
    },
    "G04": {
      "mini-herz": {
        "height": 1,
        "top": -0.05
      },
      "doppelherz": {
        "dx": 0.25
      },
      "infinity": {
        "gap": 0.15,
        "opacity": 0.45
      },
      "jesusfisch": {
        "dx": 0.15,
        "opacity": 0.45
      },
      "herz": {
        "gap": 0.1
      },
      "anker": {
        "opacity": 0.45
      }
    },
    "G05": {
      "mini-herz": {
        "height": 1,
        "top": -0.05
      },
      "jesusfisch": {
        "gap": 0.15
      },
      "infinity": {
        "gap": 0.15,
        "opacity": 0.45
      },
      "doppelherz": {
        "dx": 0.15
      },
      "anker": {
        "opacity": 0.45
      }
    },
    "G06": {
      "mini-herz": {
        "top": -0.15
      },
      "infinity": {
        "gap": 0.15,
        "top": -0.1,
        "opacity": 0.45
      },
      "jesusfisch": {
        "gap": 0.15,
        "dx": 0,
        "top": -0.1
      },
      "engel": {
        "gap": 0.1,
        "top": -0.1
      },
      "pfote": {
        "top": -0.15
      },
      "anker": {
        "top": -0.1,
        "opacity": 0.45
      },
      "doppelherz": {
        "gap": 0.15,
        "top": -0.1
      },
      "herz": {
        "top": -0.1
      }
    }
  };
  /* Bangle curvature — the engraving follows the band arc. Per [side][font]:
     every font has its own independent depth/rotate/tilt (fonts differ in
     metrics, so the arc fit differs per font; adjusting one font never moves
     another). depth: rise at the stage edge, % of stage width; rotate: char
     tilt in ° at the stage edge; tilt: whole-line (text + icons together)
     rotation in ° around the anchor — positive = links ↑ / rechts ↓.
     Missing font -> A104_CURVE_BASE, never another font's values. */
  var A104_CURVE_BASE = {
    "depth": 0,
    "rotate": 0,
    "tilt": 0
  };
  var A104_CURVE = {
    "front": {
      "G02": {
        "depth": 7,
        "rotate": 0,
        "tilt": 0
      },
      "G04": {
        "depth": 7,
        "rotate": 0,
        "tilt": 0
      },
      "G05": {
        "depth": 7.4,
        "rotate": 0,
        "tilt": 0
      },
      "G06": {
        "depth": 7.8,
        "rotate": 0,
        "tilt": 0
      }
    },
    "back": {
      "G02": {
        "depth": 0,
        "rotate": 0,
        "tilt": 0
      },
      "G04": {
        "depth": 0,
        "rotate": 0,
        "tilt": 0
      },
      "G05": {
        "depth": 0,
        "rotate": 0,
        "tilt": 0
      },
      "G06": {
        "depth": 0,
        "rotate": 0,
        "tilt": 0
      }
    }
  };
  /* Engraved look — outlined glyphs (text-stroke) with a mostly-transparent
     fill so the metal shows through, plus a faint light catch below.
     stroke/fill are per metal (option1 colour); width/highlight/iconOpacity
     here are only the neutral base. */
  var A104_ENGRAVE = {
    "width": 0.55,
    "highlight": "0 0.8px 0.8px rgba(255,255,255,0.4)",
    "iconOpacity": 0.65,
    "silver": {
      "stroke": "rgba(96,96,96,0.9)",
      "fill": "rgba(110,110,110,0.22)"
    },
    "gold": {
      "stroke": "rgba(122,96,50,0.9)",
      "fill": "rgba(138,117,80,0.22)"
    },
    "rosegold": {
      "stroke": "rgba(128,88,70,0.9)",
      "fill": "rgba(141,109,95,0.22)"
    }
  };
  /* Per-font engrave overrides: { width, highlight } — stroke thickness and
     light catch differ per font (thin script vs. bold). Missing key/property
     -> A104_ENGRAVE base, never another font's values. */
  var A104_ENGRAVE_ADJ = {
    "G02": {
      "width": 0.7
    },
    "G04": {},
    "G05": {},
    "G06": {}
  };

  var A104_FONT_STACK = {
    G02: 'NirmalaS, sans-serif',
    G04: '"Monotype Corsiva", sans-serif',
    G05: '"Bradley Hand ITC", sans-serif',
    G06: '"Murray Hill BT", sans-serif'
  };

  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function symbolSlug(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  /* Nur noch die eigene Liste — kein Umweg mehr ueber den Template-Picker. */
  function loadSymbols() {
    if (symbolsCache) return symbolsCache;
    symbolsCache = A104_SYMBOLS_FIXED.slice();
    return symbolsCache;
  }

  /* Bestellwert = "Anzeigename | CODE"; nur ueber den Code findet der
     Auftrags-Parser das Bild wieder. */
  function formatSymbolOrderValue(name) {
    var resolved = resolveSymbolName(name);
    if (!resolved) return '';
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved) {
        return symbols[i].code ? (resolved + ' | ' + symbols[i].code) : resolved;
      }
    }
    return resolved;
  }

  /* ★ Der Feldname entscheidet, ob der Parser ein Bild zeigt: "… Motiv" loest
     den Code auf, "… Text + Motiv" trennt "Text(Motiv)" selbst auf. Ein Motiv
     unter dem Label "Text" bleibt fuer immer bildlos. */
  function symbolOrderRow(title, text, symbol, withCode) {
    var t = String(text || '');
    var sym = withCode ? formatSymbolOrderValue(symbol) : resolveSymbolName(symbol);
    if (t && sym) return { name: title + ' Text + Motiv', value: t + '(' + sym + ')' };
    if (sym)      return { name: title + ' Motiv',        value: sym };
    return { name: title + ' Text', value: t };
  }

  function loadFonts() {
    if (fontsCache) return fontsCache;
    fontsCache = [];
    $('.product_info_font_json').each(function() {
      try {
        var arr = JSON.parse($(this).html());
        for (var i = 0; i < arr.length; i++) {
          if (A104_ALLOWED_FONTS.indexOf(arr[i].font_name) !== -1) {
            fontsCache.push(arr[i]);
          }
        }
      } catch (e) {}
    });
    A104_ALLOWED_FONTS.forEach(function(code) {
      if (!fontsCache.some(function(f) { return f.font_name === code; })) {
        fontsCache.push({ font_name: code, text: code, image: '' });
      }
    });
    fontsCache.sort(function(a, b) {
      return A104_ALLOWED_FONTS.indexOf(a.font_name) - A104_ALLOWED_FONTS.indexOf(b.font_name);
    });
    return fontsCache;
  }

  function getGlobalFont() {
    if (!globalFont) {
      var fonts = loadFonts();
      globalFont = fonts.length ? fonts[0] : { font_name: 'G02', text: 'NirmalaS' };
    }
    return globalFont;
  }

  // fontCode overrides the global font (used by the fixed-font KOORDINATEN /
  // RÖMISCHE ZAHLEN modes, which always render in G02 no matter the picker).
  function a104FontCode(fontCode) {
    return fontCode || getGlobalFont().font_name || 'G02';
  }

  function getFontFamilyCss(fontCode) {
    var code = a104FontCode(fontCode);
    if (A104_FONT_STACK[code]) return A104_FONT_STACK[code];
    var font = getGlobalFont();
    if (!fontCode && font.text) return font.text.indexOf(',') !== -1 ? font.text : font.text + ', sans-serif';
    return A104_FONT_STACK.G02;
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function weightedLength(str) {
    if (!str) return 0;
    var total = 0, re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += getSymbolByName(match[1]) ? A104_SYMBOL_COST : match[0].length;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  function composeLine(text, symbol) {
    return (text || '') + (symbol ? '(' + symbol + ')' : '');
  }

  function parseLineValue(raw) {
    var val = raw || '';
    var match = val.match(/\(([^)]+)\)$/);
    if (match && getSymbolByName(match[1])) {
      return { text: val.substring(0, val.length - match[0].length), symbol: match[1] };
    }
    return { text: val, symbol: '' };
  }

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.lw043SetPhysicalSideMap = setPhysicalSideMap;

  function ensureA104GravurConfig() {
    if (window.lwGravurConfig || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (config) window.lwGravurConfig = config;
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1 && label.indexOf('ros') === -1) return 'gold';
    return 'silver';
  }

  function getColorPreviewUrl() {
    return A104_PREVIEW_IMAGES[getColorKeyFromOption1()] || A104_PREVIEW_IMAGES.silver;
  }

  /* ---- KOORDINATEN (GPS → GMS) & RÖMISCHE ZAHLEN --------------------------
     Ported from A184 (product-a184-personalization.liquid). Both modes render
     one single line in a fixed font (G02) through A104's own arc/engraved-look
     pipeline, regardless of the font picker. Self-contained, a104- prefixed. */
  var A104_FIXED_MODE_FONT = 'G02';
  var A104_ROMAN_MAX = 20; // max characters the customer may type for the date
  // --- Geocoding via Google Maps (Geocoder aus der Maps JavaScript API).
  //     Publishable Browser-Key; Referrer-Beschraenkung liegt in der Google
  //     Cloud Console (viviannaschmuck.de + myshopify-Preview). ---
  var A104_GEOCODE_API_KEY = 'AIzaSyAghNIu6qTkOQQxFf8oMQQgg9E_QsHzSeU';
  var A104_GEOCODE_ENDPOINT = 'https://maps.googleapis.com/maps/api/js';
  var A104_GEOCODE_STATICMAP = 'https://maps.googleapis.com/maps/api/staticmap';

  // Roman numerals: "28.12.2024" (or "2024") -> "XXVIII · XII · MMXXIV"
  function toRoman(num) {
    num = parseInt(num, 10);
    if (!num || num < 1 || num > 3999) return '';
    var map = [[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']];
    var out = '';
    for (var i = 0; i < map.length; i++) {
      while (num >= map[i][0]) { out += map[i][1]; num -= map[i][0]; }
    }
    return out;
  }
  function romanDateResult(raw) {
    raw = String(raw || '').trim();
    var parts = raw ? raw.split(/[.\-\/\s]+/) : [];
    var out = [], anyBad = false, anyGood = false;
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      var r = toRoman(parts[i]);
      if (r) { out.push(r); anyGood = true; }
      else { anyBad = true; }
    }
    return { text: out.join(' · '), anyBad: anyBad, anyGood: anyGood };
  }
  function formatRomanDate(raw) {
    return romanDateResult(raw).text;
  }

  // GPS: decimal degrees -> GMS (Grad, Minuten, Sekunden), e.g. 48°08'12.3"N
  function toGMS(dec, isLat) {
    if (dec == null || isNaN(dec)) return '';
    var dir = isLat ? (dec >= 0 ? 'N' : 'S') : (dec >= 0 ? 'E' : 'W');
    var a = Math.abs(dec);
    var d = Math.floor(a);
    var mf = (a - d) * 60;
    var m = Math.floor(mf);
    var s = Math.round((mf - m) * 60 * 10) / 10;
    if (s >= 60) { s -= 60; m += 1; }
    if (m >= 60) { m -= 60; d += 1; }
    var mm = (m < 10 ? '0' : '') + m;
    var ss = (s < 10 ? '0' : '') + s.toFixed(1);
    return d + '°' + mm + "'" + ss + '"' + dir;
  }

  // Maps JS API einmalig nachladen. Der Geocoding-Webservice lehnt Referrer-
  // beschraenkte Keys ab, deshalb laeuft die Suche ueber google.maps.Geocoder.
  function loadGoogleMapsApi(onReady, onFail) {
    if (window.google && window.google.maps && window.google.maps.Geocoder) { onReady(); return; }
    var q = (window.__vivGmapsCallbacks = window.__vivGmapsCallbacks || []);
    q.push({ ok: onReady, fail: onFail });
    if (window.__vivGmapsLoading) return;
    window.__vivGmapsLoading = true;
    window.__vivGmapsReady = function() {
      var cb;
      while ((cb = q.shift())) { try { cb.ok(); } catch (e) {} }
    };
    var s = document.createElement('script');
    s.src = A104_GEOCODE_ENDPOINT + '?key=' + encodeURIComponent(A104_GEOCODE_API_KEY) +
      '&v=weekly&language=de&region=DE&loading=async&callback=__vivGmapsReady';
    s.async = true;
    s.onerror = function() {
      window.__vivGmapsLoading = false;
      var cb;
      while ((cb = q.shift())) { try { cb.fail(); } catch (e) {} }
    };
    document.head.appendChild(s);
  }
  function geocodeAddress(address, onOk, onErr) {
    if (!A104_GEOCODE_API_KEY) { onErr('no-key'); return; }
    loadGoogleMapsApi(function() {
      try {
        new window.google.maps.Geocoder().geocode({ address: address, region: 'DE' }, function(results, status) {
          if (status === 'OK' && results && results.length) {
            var loc = results[0].geometry.location;
            onOk(loc.lat(), loc.lng(), results[0].formatted_address || '');
          } else if (status === 'ZERO_RESULTS') { onErr('not-found'); }
          else { onErr('network'); }
        });
      } catch (e) { onErr('network'); }
    }, function() { onErr('network'); });
  }
  function buildStaticMapUrl(lat, lng) {
    if (!A104_GEOCODE_API_KEY) return '';
    return A104_GEOCODE_STATICMAP + '?key=' + encodeURIComponent(A104_GEOCODE_API_KEY) +
      '&center=' + lat + ',' + lng + '&zoom=16&size=600x260&format=png&language=de' +
      '&markers=color:red%7C' + lat + ',' + lng;
  }

  // ---- per-side mode state (freitext / koordinaten / roemische_zahlen) ----
  function getSideEl(sideIndex) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
  }
  function getSideMode(sideIndex) {
    return getSideEl(sideIndex).attr('data-a104-mode') || 'freitext';
  }
  function getSideKoordGms(sideIndex) {
    return $.trim(getSideEl(sideIndex).find('.a104-koord-gms').val() || '');
  }
  function getSideKoordAddress(sideIndex) {
    return $.trim(getSideEl(sideIndex).find('.a104-koord-address').val() ||
      getSideEl(sideIndex).find('.a104-koord-input').val() || '');
  }
  function getKoordText(sideIndex) {
    var gms = getSideKoordGms(sideIndex);
    if (!gms) return '';
    var p = gms.split('|');
    return $.trim((p[0] || '') + ' ' + (p[1] || ''));
  }
  function getSideRomanRaw(sideIndex) {
    return $.trim(getSideEl(sideIndex).find('.a104-roman-input').val() || '');
  }
  function getRomanText(sideIndex) {
    return formatRomanDate(getSideRomanRaw(sideIndex));
  }

  function updateFontGridVisibility() {
    var anyFixed = false;
    $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').each(function() {
      if (($(this).attr('data-a104-mode') || 'freitext') !== 'freitext') anyFixed = true;
    });
    $('.up-Fenster-p-personalization-1 .a104-global-font').css('display', anyFixed ? 'none' : '');
  }

  function getLineSymbol(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    return $side.attr('data-a104-symbol-line1') || '';
  }

  function setLineSymbol(sideIndex, sym) {
    $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex)
      .attr('data-a104-symbol-line1', sym || '');
  }

  function getLineInput(sideIndex) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex)
      .find('.a104-line-input');
  }

  function getSideData(sideIndex) {
    var parsed = parseLineValue(getLineInput(sideIndex).val() || '');
    return {
      text: parsed.text,
      symbol: parsed.symbol || getLineSymbol(sideIndex)
    };
  }

  function sideHasContent(sideIndex) {
    var mode = getSideMode(sideIndex);
    if (mode === 'koordinaten') return !!getKoordText(sideIndex);
    if (mode === 'roemische_zahlen') return !!getRomanText(sideIndex);
    var d = getSideData(sideIndex);
    return !!composeLine(d.text, d.symbol);
  }

  function toggleLineClear($input, value) {
    var hasContent = !!(value && String(value).trim());
    $input.siblings('.a104-line-clear').css('display', hasContent ? 'block' : 'none');
  }

  function syncLineInputComposed($input, text, symbol) {
    var composed = composeLine(text, symbol);
    $input.val(composed);
    toggleLineClear($input, composed);
    return composed;
  }

  function updateLineCounter($input) {
    var idx = getSideIndexFromEl($input);
    var parsed = parseLineValue($input.val() || '');
    var sym = parsed.symbol || getLineSymbol(idx);
    var len = weightedLength(composeLine(parsed.text, sym));
    $input.closest('.a104-line-input-wrap').find('.a104-line-counter')
      .html('<span class="a104-count">' + len + '</span> / ' + A104_CHAR_MAX);
    toggleLineClear($input, $input.val());
  }

  function syncSymbolGridForSide(sideIndex) {
    var selected = getLineSymbol(sideIndex);
    var $grid = $('.product_info_main_' + sideIndex).find('.a104-symbol-grid');
    $grid.find('button').removeClass('is-active');
    if (selected) $grid.find('button[data-symbol="' + selected + '"]').addClass('is-active');
  }

  function applyFontToInputs() {
    var fontCode = getGlobalFont().font_name || 'G02';
    $('.up-Fenster-p-personalization-1 .a104-line-input')
      .attr('data-a104-font', fontCode)
      .css('font-family', getFontFamilyCss());
  }

  /* ---------------------------- preview render ---------------------------- */

  function getSideKey(physicalSide) {
    return physicalSide === 1 ? 'back' : 'front';
  }

  function getTextAdj(sideKey, fontCode) {
    var code = a104FontCode(fontCode);
    return (A104_TEXT_ADJ[sideKey] || {})[code] || { mult: 1 };
  }

  function getTextPos(sideKey, fontCode) {
    var code = a104FontCode(fontCode);
    return (A104_TEXT_POS[sideKey] || {})[code] || A104_TEXT_POS_BASE;
  }

  function getIconGeom(slug, fontCode) {
    var font = a104FontCode(fontCode);
    var o = (A104_ICON_ADJ[font] || {})[slug] || {};
    return {
      height: o.height != null ? o.height : A104_ICON.height,
      top: o.top != null ? o.top : A104_ICON.top,
      gap: o.gap != null ? o.gap : A104_ICON.gap,
      dx: o.dx != null ? o.dx : (A104_ICON.dx || 0),
      rot: o.rot != null ? o.rot : (A104_ICON.rot || 0),
      opacity: o.opacity != null ? o.opacity : A104_ENGRAVE.iconOpacity
    };
  }

  function getCurve(sideKey, fontCode) {
    var font = a104FontCode(fontCode);
    return (A104_CURVE[sideKey] || {})[font] || A104_CURVE_BASE;
  }

  function getEngraveAdj(fontCode) {
    var font = a104FontCode(fontCode);
    return A104_ENGRAVE_ADJ[font] || {};
  }

  function getEngraveWidth(fontCode) {
    var a = getEngraveAdj(fontCode);
    return a.width != null ? a.width : A104_ENGRAVE.width;
  }

  function getEngraveHighlight(fontCode) {
    var a = getEngraveAdj(fontCode);
    return a.highlight != null ? a.highlight : A104_ENGRAVE.highlight;
  }

  function getMaxWidthPct(sideKey, fontCode) {
    var adj = getTextAdj(sideKey, fontCode);
    return adj.wmax != null ? adj.wmax : A104_TEXT_MAX_WIDTH_PCT;
  }

  function getMaxHeightPct(sideKey, fontCode) {
    var adj = getTextAdj(sideKey, fontCode);
    return adj.hmax != null ? adj.hmax : A104_TEXT_MAX_HEIGHT_PCT;
  }

  function charSpans(text) {
    var html = '';
    for (var i = 0; i < text.length; i++) {
      html += '<span class="a104-ch">' + esc(text.charAt(i)) + '</span>';
    }
    return html;
  }

  function buildEngravingHtml(raw, fontCode) {
    if (!raw) return '';
    var html = '', re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      if (match.index > last) html += charSpans(raw.substring(last, match.index));
      var sym = getSymbolByName(match[1]);
      if (sym && sym.image) {
        var g = getIconGeom(symbolSlug(sym.text), fontCode);
        html += '<img class="a104-preview-symbol a104-preview-symbol--' + esc(symbolSlug(sym.text)) + '"' +
          ' data-a104-dx="' + g.dx + '" data-a104-rot="' + g.rot + '"' +
          ' style="height:' + g.height + 'em;position:relative;top:' + g.top + 'em;margin-left:' + g.gap + 'em;vertical-align:middle;' +
          'opacity:' + g.opacity + ';"' +
          ' src="' + esc(sym.image) + '" alt="' + esc(match[1]) + '">';
      } else {
        html += charSpans('(' + match[1] + ')');
      }
      last = re.lastIndex;
    }
    if (last < raw.length) html += charSpans(raw.substring(last));
    return html;
  }

  /* Shift + tilt every char/icon along a parabola fixed in stage space so the
     engraving hugs the bangle arc. `scale` is the fit-to-width factor already
     applied to the line, so the arc stays in visual (post-scale) coordinates. */
  function applyA104Curve(el, scale, stageW) {
    var sideKey = el.getAttribute('data-a104-side') || 'front';
    var fontCode = el.getAttribute('data-a104-font-code') || undefined;
    var curve = getCurve(sideKey, fontCode);
    var depthPx = (curve.depth || 0) / 100 * stageW;
    var halfStage = stageW / 2;
    var mid = el.scrollWidth / 2;
    var kids = el.querySelectorAll('.a104-ch, img');
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      var dxLayout = (k.offsetLeft + k.offsetWidth / 2) - mid;
      var t = halfStage > 0 ? (dxLayout * scale) / halfStage : 0;
      var dyVis = -depthPx * t * t;
      var dyLayout = scale > 0 ? dyVis / scale : dyVis;
      var angle = -(curve.rotate || 0) * t;
      // Per-icon own left/right nudge (dx, em) + own rotation (rot, °),
      // composed with the arc's shift/tilt. Text chars have neither.
      var iconDx = 0, iconRot = 0;
      if (k.tagName === 'IMG') {
        iconDx = parseFloat(k.getAttribute('data-a104-dx')) || 0;
        iconRot = parseFloat(k.getAttribute('data-a104-rot')) || 0;
      }
      k.style.transform = 'translateY(' + dyLayout + 'px)' +
        (iconDx ? ' translateX(' + iconDx + 'em)' : '') +
        ' rotate(' + (angle + iconRot) + 'deg)';
    }
  }

  function fitPreviewTextWidths() {
    var stage = $('[data-a104-preview-stage]')[0];
    if (!stage || !stage.clientWidth) return;
    var stageW = stage.clientWidth;
    $('[data-a104-preview-stage] .a104-preview-text').each(function() {
      var sideKey = this.getAttribute('data-a104-side') || 'front';
      var fontCode = this.getAttribute('data-a104-font-code') || undefined;
      var maxW = stageW * (getMaxWidthPct(sideKey, fontCode) / 100);
      var maxH = stageW * (getMaxHeightPct(sideKey, fontCode) / 100);
      var tilt = getCurve(sideKey, fontCode).tilt || 0;
      var tiltCss = tilt ? ' rotate(' + tilt + 'deg)' : '';
      this.style.transform = 'translate(-50%, -50%)' + tiltCss;
      var w = this.scrollWidth;
      var h = this.scrollHeight;
      var scale = 1;
      if (w > 0 && maxW > 0 && w > maxW) {
        scale = maxW / w;
      }
      if (maxH > 0 && h > 0 && h * scale > maxH) {
        scale = maxH / h;
      }
      if (scale !== 1) {
        this.style.transform = 'translate(-50%, -50%) scale(' + scale + ')' + tiltCss;
      }
      applyA104Curve(this, scale, stageW);
    });
  }

  function scheduleFitPreviewTextWidths() {
    requestAnimationFrame(function() {
      fitPreviewTextWidths();
      requestAnimationFrame(fitPreviewTextWidths);
    });
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-a104-preview-stage] .a104-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();
    var metal = A104_ENGRAVE[getColorKeyFromOption1()] || A104_ENGRAVE.silver;

    for (var i = 0; i < zu; i++) {
      var mode = getSideMode(i);
      var raw, fc;
      if (mode === 'koordinaten') { raw = getKoordText(i); fc = A104_FIXED_MODE_FONT; }
      else if (mode === 'roemische_zahlen') { raw = getRomanText(i); fc = A104_FIXED_MODE_FONT; }
      else {
        var d = getSideData(i);
        raw = composeLine(d.text, d.symbol);
        fc = getGlobalFont().font_name || 'G02';
      }
      if (!raw) continue;
      var fcl = String(fc).toLowerCase();
      var sideKey = getSideKey(getPhysicalSideIndex(i));
      var pos = getTextPos(sideKey, fc);
      var adj = getTextAdj(sideKey, fc);
      var style =
        'left:' + pos.x + '%;' +
        'top:' + pos.y + '%;' +
        'font-size:calc(' + A104_TEXT_BASE_SIZE + 'cqw * ' + (adj.mult != null ? adj.mult : 1) + ');' +
        'color:' + metal.fill + ';' +
        '-webkit-text-stroke:' + getEngraveWidth(fc) + 'px ' + metal.stroke + ';' +
        (getEngraveHighlight(fc) && getEngraveHighlight(fc) !== 'none'
          ? 'text-shadow:' + getEngraveHighlight(fc) + ';' : '') +
        'font-family:' + getFontFamilyCss(fc) + ';';
      $layers.append(
        '<div class="a104-preview-text a104-preview-font-' + fcl + '" data-a104-side="' + sideKey + '" data-a104-font-code="' + fc + '" style="' + style + '">' +
        buildEngravingHtml(raw, fc) + '</div>'
      );
    }
    scheduleFitPreviewTextWidths();
    $layers.find('.a104-preview-text img').off('load.a104Fit').on('load.a104Fit', fitPreviewTextWidths);
    if ($layers.find('.a104-preview-text img').filter(function() { return this.complete; }).length) {
      fitPreviewTextWidths();
    }
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;
    if (!$host.find('.a104-preview-wrap').length) {
      $host.prepend(
        '<div class="a104-preview-wrap">' +
          '<div class="a104-preview-label">Vorschau</div>' +
          '<div class="a104-preview-stage" data-a104-preview-stage>' +
            /* NIE loading="lazy" (GOTCHAS 27): das Fenster faehrt von ausserhalb des
               Viewports herein — dort laedt der Browser ein lazy-Bild nicht, und er
               prueft es beim Hereinfahren auch nicht neu. Das Basisbild bliebe grau,
               ohne Fehler in der Konsole (complete=false, naturalWidth 0). Real
               gemessen bei KS017, A203 und A227; Bestand am 2026-09-15 bereinigt. */
            '<img class="a104-preview-base" alt="">' +
            '<div class="a104-preview-layers"></div>' +
          '</div>' +
        '</div>'
      );
    }
    if (!$host.find('.a104-global-font').length) {
      $host.find('.a104-preview-wrap').after(
        '<div class="a104-global-font">' +
          '<div class="a104-global-font-label">Schriftart</div>' +
          '<div class="a104-font-grid" data-a104-font-grid></div>' +
        '</div>'
      );
      renderFontGrid();
    }
  }

  function renderFontGrid() {
    var fonts = loadFonts();
    var current = getGlobalFont();
    var html = '';
    for (var i = 0; i < fonts.length; i++) {
      var f = fonts[i];
      var active = f.font_name === current.font_name;
      var gname = String(f.font_name || '');
      // [2] Probetext = der Schriftname selbst, in dieser Schrift (Yin 2026-08-15)
      html += '<button type="button" class="a104-font-zeile' + (active ? ' is-active' : '') + '" data-font="' + esc(gname) + '" data-family="' + esc(f.text) + '" data-value="' + esc(gname) + '">' +
        '<span class="a104-font-probe" style="font-family:' + esc(f.text) + ';">' + esc(gname) + '</span>' +
        '<span class="a104-font-code">' + esc(gname) + '</span>' +
        '<span class="a104-font-haken">&#10003;</span>' +
      '</button>';
    }
    $('[data-a104-font-grid]').html(html);
  }

  function buildSymbolGrid(sideIndex) {
    var symbols = loadSymbols();
    var selected = getLineSymbol(sideIndex);
    var html = '<div class="a104-symbol-grid" data-side="' + sideIndex + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = sym.text === selected ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="a104-symbol-label">' + esc(sym.text) + '</span></button>';
    }
    return html + '</div>';
  }

  function buildKoordPanel(sideIndex) {
    return '<div class="a104-mode-panel" data-mode-panel="koordinaten" data-side="' + sideIndex + '" style="display:none">' +
      '<div class="a104-line-label">Adresse / Ort</div>' +
      '<div class="a104-koord-row">' +
        '<input type="text" class="a104-koord-input" placeholder="z. B. Marienplatz 1, München" autocomplete="off">' +
        '<button type="button" class="a104-koord-btn">Suchen</button>' +
      '</div>' +
      '<div class="a104-koord-status" aria-live="polite"></div>' +
      '<div class="a104-koord-result" style="display:none">' +
        '<div class="a104-koord-found"></div>' +
        '<img class="a104-koord-map" alt="Karte" loading="lazy" onerror="this.style.display=\'none\'">' +
        '<div class="a104-koord-confirm-row">' +
          '<button type="button" class="a104-koord-confirm">Übernehmen</button>' +
          '<span class="a104-koord-gmshint"></span>' +
        '</div>' +
      '</div>' +
      '<input type="hidden" class="a104-koord-gms">' +
      '<input type="hidden" class="a104-koord-address">' +
      '<input type="hidden" class="a104-koord-pending-gms">' +
      '<input type="hidden" class="a104-koord-pending-address">' +
    '</div>';
  }
  function buildRomanPanel(sideIndex) {
    return '<div class="a104-mode-panel" data-mode-panel="roemische_zahlen" data-side="' + sideIndex + '" style="display:none">' +
      '<div class="a104-line-label">Datum</div>' +
      '<div class="a104-line-input-wrap">' +
        '<input type="text" class="a104-roman-input" maxlength="' + A104_ROMAN_MAX + '" data-maxlen="' + A104_ROMAN_MAX + '" placeholder="TT.MM.JJJJ" autocomplete="off">' +
      '</div>' +
      '<span class="a104-char-hint">z. B. 28.12.2024 → XXVIII · XII · MMXXIV · max. ' + A104_ROMAN_MAX + ' Zeichen</span>' +
      '<div class="a104-roman-status" aria-live="polite"></div>' +
    '</div>';
  }

  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;
    $side.find('.pattles-tab-header').hide();

    if (!$side.find('.a104-mode-switch').length) {
      $side.attr('data-a104-mode', 'freitext');
      $side.find('.pattles-message-header').after(
        /* Die data-mode-Werte bleiben exakt die alten (freitext / koordinaten /
           roemische_zahlen) — getSideMode, Speicherstand und Bestellausgabe
           haengen daran. Getauscht wird nur das Aussehen (K530-Karten). */
        '<div class="a104-mode-switch" data-side="' + sideIndex + '">' +
          '<button type="button" class="is-active" data-mode="freitext"><span class="a104-layout-name">Text</span><span class="a104-layout-sub">z.B. ein Name</span></button>' +
          '<button type="button" data-mode="koordinaten"><span class="a104-layout-name">Koordinaten</span><span class="a104-layout-sub">GPS als Gravur</span></button>' +
          '<button type="button" data-mode="roemische_zahlen"><span class="a104-layout-name">Römische Zahlen</span><span class="a104-layout-sub">Datum in Ziffern</span></button>' +
        '</div>' +
        '<div class="a104-mode-panel" data-mode-panel="freitext" data-side="' + sideIndex + '">' +
          '<div class="a104-line-block">' +
            '<div class="a104-line-label">Gravur</div>' +
            '<div class="a104-line-input-wrap">' +
              '<input type="text" class="a104-line-input" data-side="' + sideIndex + '" data-max="' + A104_CHAR_MAX + '">' +
              '<div class="a104-line-clear" style="display:none"></div>' +
              '<span class="a104-line-counter"><span class="a104-count">0</span> / ' + A104_CHAR_MAX + '</span>' +
            '</div>' +
            buildSymbolGrid(sideIndex) +
          '</div>' +
        '</div>' +
        buildKoordPanel(sideIndex) +
        buildRomanPanel(sideIndex) +
        '<p class="a104-side-error">Bitte fülle die Gravur für diese Seite aus.</p>'
      );
    }
    updateLineCounter(getLineInput(sideIndex));
    /* [2] Kontext-Schriftart: der Schrift-Block wandert IN das Freitext-Panel
       (ueber die Textzeile). Bleibt derselbe Knoten — getGlobalFont, Restore
       und Bestellausgabe lesen ihn unveraendert. */
    var $gf = $('.up-Fenster-p-personalization-1 .a104-global-font');
    var $frei = $side.find('.a104-mode-panel[data-mode-panel="freitext"]');
    if ($gf.length && $frei.length && !$frei.find('.a104-global-font').length) $frei.prepend($gf);
    updateFontGridVisibility();
  }

  window.a104UpdatePreview = function() {
    ensurePreviewShell();
    $('[data-a104-preview-stage] .a104-preview-base').attr('src', getColorPreviewUrl());
    renderAllPreviewEngravings();
    if (window.__a104RefreshTuner) window.__a104RefreshTuner();
  };

  function bindEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    $popup.off('click.a104Font', '[data-a104-font-grid] button').on('click.a104Font', '[data-a104-font-grid] button', function() {
      globalFont = { font_name: $(this).data('font'), text: $(this).data('family') };
      $('[data-a104-font-grid] button').removeClass('is-active');
      $(this).addClass('is-active');
      applyFontToInputs();
      $('.up-Fenster-p-personalization-1 .a104-line-input').each(function() {
        updateLineCounter($(this));
      });
      window.a104UpdatePreview();
    });

    $popup.off('input.a104Line', '.a104-line-input').on('input.a104Line', '.a104-line-input', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      var parsed = parseLineValue(($input.val() || '').replace(/[\r\n]/g, ''));
      setLineSymbol(idx, parsed.symbol);
      var text = parsed.text;
      var symbol = parsed.symbol || getLineSymbol(idx);
      while (weightedLength(composeLine(text, symbol)) > A104_CHAR_MAX && text.length) {
        text = text.slice(0, -1);
      }
      syncLineInputComposed($input, text, symbol);
      syncSymbolGridForSide(idx);
      updateLineCounter($input);
      window.a104UpdatePreview();
    });

    $popup.off('click.a104Symbol', '.a104-symbol-grid button').on('click.a104Symbol', '.a104-symbol-grid button', function() {
      var $grid = $(this).closest('.a104-symbol-grid');
      var idx = parseInt($grid.attr('data-side'), 10);
      var symName = $(this).data('symbol');
      var $input = getLineInput(idx);
      var parsed = parseLineValue($input.val() || '');
      if (weightedLength(composeLine(parsed.text, symName)) > A104_CHAR_MAX) return;

      setLineSymbol(idx, symName);
      syncLineInputComposed($input, parsed.text, symName);
      syncSymbolGridForSide(idx);
      updateLineCounter($input);
      window.a104UpdatePreview();
    });

    $popup.off('click.a104Clear', '.a104-line-clear').on('click.a104Clear', '.a104-line-clear', function() {
      var $input = $(this).siblings('.a104-line-input');
      var idx = getSideIndexFromEl($input);
      setLineSymbol(idx, '');
      $input.val('');
      toggleLineClear($input, '');
      syncSymbolGridForSide(idx);
      updateLineCounter($input);
      window.a104UpdatePreview();
    });

    // ---- mode switch: Freitext / Koordinaten / Römische Zahlen ----
    $popup.off('click.a104Mode', '.a104-mode-switch button').on('click.a104Mode', '.a104-mode-switch button', function() {
      var $btn = $(this);
      var idx = parseInt($btn.closest('.a104-mode-switch').attr('data-side'), 10);
      var mode = $btn.attr('data-mode');
      $btn.addClass('is-active').siblings().removeClass('is-active');
      var $side = $('.product_info_main_' + idx);
      $side.attr('data-a104-mode', mode);
      $side.find('.a104-mode-panel').hide();
      $side.find('.a104-mode-panel[data-mode-panel="' + mode + '"]').show();
      updateFontGridVisibility();
      window.a104UpdatePreview();
    });

    // ---- RÖMISCHE ZAHLEN: cap length, warn out-of-range, live conversion ----
    $popup.off('input.a104Roman', '.a104-roman-input').on('input.a104Roman', '.a104-roman-input', function() {
      if (this.value.length > A104_ROMAN_MAX) this.value = this.value.slice(0, A104_ROMAN_MAX);
      var res = romanDateResult(this.value);
      var $st = $(this).closest('.a104-mode-panel[data-mode-panel="roemische_zahlen"]').find('.a104-roman-status');
      if (res.anyBad && !res.anyGood) $st.text('Bitte ein gültiges Datum eingeben (Zahlen 1–3999).');
      else if (res.anyBad) $st.text('Ein Wert ist zu groß – römische Zahlen gehen nur bis 3999.');
      else $st.text('');
      window.a104UpdatePreview();
    });
    $popup.off('keydown.a104Roman', '.a104-roman-input').on('keydown.a104Roman', '.a104-roman-input', function(e) {
      if (e.key === 'Enter') e.preventDefault();
    });

    // ---- KOORDINATEN: geocode → verify address + map → Übernehmen ----
    $popup.off('keydown.a104KoordIn', '.a104-koord-input').on('keydown.a104KoordIn', '.a104-koord-input', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); $(this).closest('.a104-mode-panel').find('.a104-koord-btn').trigger('click'); }
    });
    $popup.off('click.a104KoordBtn', '.a104-koord-btn').on('click.a104KoordBtn', '.a104-koord-btn', function() {
      var $panel = $(this).closest('.a104-mode-panel[data-mode-panel="koordinaten"]');
      var addr = $.trim($panel.find('.a104-koord-input').val() || '');
      var $status = $panel.find('.a104-koord-status');
      var $result = $panel.find('.a104-koord-result');
      $result.hide();
      if (addr.length < 3) { $status.text('Bitte gib eine vollständige Adresse ein.'); return; }
      $status.text('Suche…');
      geocodeAddress(addr, function(lat, lng, disp) {
        var latStr = toGMS(lat, true), lngStr = toGMS(lng, false);
        $panel.find('.a104-koord-pending-gms').val(latStr + '|' + lngStr);
        $panel.find('.a104-koord-pending-address').val(disp || addr);
        $panel.find('.a104-koord-found').text(disp || addr);
        $panel.find('.a104-koord-gmshint').text(latStr + '  ·  ' + lngStr);
        var mapUrl = buildStaticMapUrl(lat, lng);
        var $map = $panel.find('.a104-koord-map');
        if (mapUrl) { $map.attr('src', mapUrl).css('display', ''); } else { $map.hide(); }
        $status.text('Stimmt der Ort? Dann auf „Übernehmen".');
        $result.show();
      }, function(err) {
        $status.text(
          err === 'no-key' ? 'Koordinaten-Suche noch nicht konfiguriert.' :
          err === 'not-found' ? 'Adresse nicht gefunden – bitte genauer angeben.' :
          'Suche fehlgeschlagen – bitte erneut versuchen.'
        );
      });
    });
    $popup.off('click.a104KoordConfirm', '.a104-koord-confirm').on('click.a104KoordConfirm', '.a104-koord-confirm', function() {
      var $panel = $(this).closest('.a104-mode-panel[data-mode-panel="koordinaten"]');
      var pg = $.trim($panel.find('.a104-koord-pending-gms').val() || '');
      if (!pg) return;
      $panel.find('.a104-koord-gms').val(pg);
      $panel.find('.a104-koord-address').val($.trim($panel.find('.a104-koord-pending-address').val() || ''));
      $panel.find('.a104-koord-status').text('✓ Ort übernommen.');
      window.a104UpdatePreview();
    });

    if (!window._a104PreviewFitResize) {
      window._a104PreviewFitResize = true;
      $(window).on('resize.a104PreviewFit', fitPreviewTextWidths);
    }
  }

  /* --------------------- popup engine hooks (lw043 family) --------------------- */

  window.lw043ValidateBeforeOpen = function() {
    return true;
  };

  window.lw043AfterUpdateSize = function(zu) {
    ensureA104GravurConfig();
    var gravurConfig = window.lwGravurConfig;
    if (gravurConfig && gravurConfig.physicalSides) {
      setPhysicalSideMap(gravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) return;
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) setupSide(i);
    renderFontGrid();
    applyFontToInputs();
    bindEvents();
    window.a104UpdatePreview();
  };

  window.lw043OnPopupOpen = function() {
    symbolsCache = null;
    fontsCache = null;
    if (window.lw043RefreshPopupSides) lw043RefreshPopupSides();
    ensurePreviewShell();
    previewSideCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length || previewSideCount;
    if (window.lw043AfterUpdateSize) lw043AfterUpdateSize(previewSideCount);
    else { bindEvents(); window.a104UpdatePreview(); }
    buildA104Tuner();
  };

  window.lw043OnPopupClose = function() {
    $('.product-info--lw043 [class*="product_info_main_"]').removeClass('has-error');
  };

  window.lw043ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var valid = true;
    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      $side.removeClass('has-error');
      $side.find('.a104-side-error').hide();
      if (!sideHasContent(i)) {
        valid = false;
        $side.addClass('has-error');
        $side.find('.a104-side-error').show();
      }
    }
    if (!valid) {
      alert('Bitte fülle die Gravur aus.');
      /* [6] Fokus-Regel: den (roten) Kopf der Problemseite anspringen. */
      var $kopf = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"].has-error').first();
      var scrollEl = $('.up-Fenster-p-personalization-1').find('.fenster-content-inner, .fenster-content-contentin').get(0);
      if ($kopf.length && scrollEl) {
        scrollEl.scrollTop = Math.max(0, $kopf[0].getBoundingClientRect().top - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - 8);
      }
    }
    return valid;
  };

  window.lw043AppendSideProperties = function(properies_arr, zu, popup_title) {
    var fontName = getGlobalFont().font_name;
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var mode = getSideMode(i);
      if (mode === 'koordinaten') {
        var gms = getSideKoordGms(i);
        var koordOut = gms ? gms.replace('|', ' / ') : '';
        if (koordOut) {
          properies_arr.push([title + ' KOORDINATEN', koordOut]);
          var addr = getSideKoordAddress(i);
          if (addr) properies_arr.push([title + ' KOORDINATEN Adresse', addr]);
          properies_arr.push([title + ' KOORDINATEN Font', A104_FIXED_MODE_FONT]);
        }
        continue;
      }
      if (mode === 'roemische_zahlen') {
        var romanRaw = getSideRomanRaw(i);
        var romanOut = formatRomanDate(romanRaw);
        if (romanOut) {
          properies_arr.push([title + ' RÖMISCHE ZAHLEN', romanOut]);
          if (romanRaw) properies_arr.push([title + ' RÖMISCHE ZAHLEN Datum', romanRaw]);
          properies_arr.push([title + ' RÖMISCHE ZAHLEN Font', A104_FIXED_MODE_FONT]);
        }
        continue;
      }
      var d = getSideData(i);
      var orderRow = symbolOrderRow(title, d.text, d.symbol, true);
      if ($.trim(orderRow.value)) {
        properies_arr.push([orderRow.name, orderRow.value]);
        if (d.text) properies_arr.push([title + ' Font', fontName]);
      }
    }
  };

  window.lw043ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';
    var fontName = getGlobalFont().font_name;

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var mode = getSideMode(i);
      if (mode === 'koordinaten') {
        var gms = getSideKoordGms(i);
        var koordOut = gms ? gms.replace('|', ' / ') : '';
        if (koordOut) {
          html += template.replaceAll('{option_name}', title + ' KOORDINATEN').replaceAll('{option_value}', koordOut);
          var addr = getSideKoordAddress(i);
          if (addr) html += template.replaceAll('{option_name}', title + ' Adresse').replaceAll('{option_value}', addr);
          html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', A104_FIXED_MODE_FONT);
        }
        continue;
      }
      if (mode === 'roemische_zahlen') {
        var romanOut = getRomanText(i);
        if (romanOut) {
          html += template.replaceAll('{option_name}', title + ' RÖMISCHE ZAHLEN').replaceAll('{option_value}', romanOut);
          html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', A104_FIXED_MODE_FONT);
        }
        continue;
      }
      var d = getSideData(i);
      var composed = composeLine(d.text, d.symbol);
      if (composed) {
        var confirmRow = symbolOrderRow(title, d.text, d.symbol, false);
        html += template.replaceAll('{option_name}', confirmRow.name).replaceAll('{option_value}', confirmRow.value);
        if (d.text) html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', fontName);
      }
    }
    if (html) {
      /* [7] Platzhalter fuer den Vorschau-Streifen — befuellt per DOM-Klon
         NACH dem Einhaengen der Bestaetigungsseite (a104EnhanceConfirmOptions). */
      html = '<div class="a104-confirm-vorschau" aria-hidden="true"></div>' + html;
    }
    return html;
  };

  /* [7] Vorschau-Streifen: klont die live gerenderte Buehne aus dem Popup.
     ⚠ Messfalle: beim Bestaetigen ist das Popup zu (Buehne 0px) — darum
     unsichtbar messbar machen (fixed, -9999px), rendern, klonen, zurueck. */
  function a104FillConfirmVorschau() {
    var $ziel = $('.message-confirm-item-2 .a104-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;
    var altStyle = $popup.attr('style') || '';
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    window.a104UpdatePreview();
    var $stage = $('[data-a104-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      var ZIEL_B = Math.max(64, Math.min(160, $ziel.width() || 320));
      var f = ZIEL_B / sw;
      var $clip = $('<div class="a104-cv-clip"></div>')
        .css({ width: ZIEL_B + 'px', height: Math.ceil(sh * f) + 'px', overflow: 'hidden' });
      var $scale = $('<div class="a104-cv-scale"></div>')
        .css({ width: sw + 'px', transform: 'scale(' + f + ')', 'transform-origin': 'top left' });
      $scale.append($stage.clone());
      $clip.append($scale);
      $ziel.append($('<div class="a104-cv-item"></div>')
        .css('width', ZIEL_B + 'px')
        .append($clip)
        .append('<div class="a104-cv-name">Vorderseite</div>'));
    }
    $popup.attr('style', altStyle);
  }

  window.a104EnhanceConfirmOptions = function() {
    /* laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
       der Handler dort ist synchron, also reicht ein Tick Verzoegerung. */
    setTimeout(a104FillConfirmVorschau, 0);
  };

  $(document).on('change.a104Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.a104UpdatePreview();
  });
  $(document).on('change.a104GravurOption', '[name="option2"]', function() {
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.a104UpdatePreview();
  });

  /* ------------------------------- A104 tuner ------------------------------- */

  function a104TunerEnabled() {
    try {
      return /a104tuner/.test(String(window.location.search) + String(window.location.hash));
    } catch (e) { return false; }
  }

  function buildA104Tuner() {
    if (!a104TunerEnabled() || document.getElementById('a104-tuner')) return;
    if (!window.__a104TunerSide) window.__a104TunerSide = 'front';

    function tunerSide() {
      return getActiveSideCount() > 1 ? (window.__a104TunerSide || 'front') : 'front';
    }
    function tunerSideIndex() {
      return tunerSide() === 'back' ? 1 : 0;
    }

    // one <input> per knob, with its own listener so typing never loses focus
    function makeRow(item) {
      if (item.h) { var hh = document.createElement('h5'); hh.textContent = item.h; return hh; }
      var row = document.createElement('div'); row.className = 'kt-row';
      var lab = document.createElement('label'); lab.textContent = item.label; lab.title = item.label;
      var inp = document.createElement('input');
      if (item.type === 'text') {
        inp.type = 'text';
        inp.value = item.get() || '';
        inp.addEventListener('input', function() {
          item.set(inp.value); window.a104UpdatePreview();
        });
      } else {
        inp.type = 'number'; inp.step = item.step || 0.5;
        var v = item.get(); inp.value = (v == null ? '' : v);
        inp.addEventListener('input', function() {
          var n = parseFloat(inp.value);
          if (!isNaN(n)) { item.set(n); window.a104UpdatePreview(); }
        });
      }
      row.appendChild(lab); row.appendChild(inp);
      return row;
    }
    function renderInto(box, items) {
      box.innerHTML = '';
      for (var i = 0; i < items.length; i++) box.appendChild(makeRow(items[i]));
    }

    function staticItems() {
      var it = [];
      var sk = tunerSide();
      it.push({ h: 'Global · Basiswerte (Fallback)' });
      it.push({ label: 'Text-Basisgröße cqw', step: 0.1, get: function() { return A104_TEXT_BASE_SIZE; }, set: function(v) { A104_TEXT_BASE_SIZE = v; } });
      it.push({ label: 'Breite max % (Basis)', step: 1, get: function() { return A104_TEXT_MAX_WIDTH_PCT; }, set: function(v) { A104_TEXT_MAX_WIDTH_PCT = v; } });
      it.push({ label: 'Höhe max % Basis (0=aus)', step: 0.5, get: function() { return A104_TEXT_MAX_HEIGHT_PCT; }, set: function(v) { A104_TEXT_MAX_HEIGHT_PCT = v; } });
      it.push({ h: 'Text-Größe × pro Font (' + (sk === 'back' ? 'Rückseite' : 'Vorderseite') + ')' });
      A104_ALLOWED_FONTS.forEach(function(fontCode) {
        function ensureFontAdj() {
          var s = (A104_TEXT_ADJ[sk] = A104_TEXT_ADJ[sk] || {});
          return (s[fontCode] = s[fontCode] || { mult: 1 });
        }
        it.push({
          label: fontCode + ' Größe ×', step: 0.02,
          get: function() {
            var a = (A104_TEXT_ADJ[sk] || {})[fontCode] || {};
            return a.mult != null ? a.mult : 1;
          },
          set: function(v) { ensureFontAdj().mult = v; }
        });
      });
      it.push({ h: 'Gravur-Farben (pro Metall)' });
      it.push({ label: 'Silber Kontur', type: 'text', get: function() { return A104_ENGRAVE.silver.stroke; }, set: function(v) { A104_ENGRAVE.silver.stroke = v; } });
      it.push({ label: 'Silber Füllung', type: 'text', get: function() { return A104_ENGRAVE.silver.fill; }, set: function(v) { A104_ENGRAVE.silver.fill = v; } });
      it.push({ label: 'Gold Kontur', type: 'text', get: function() { return A104_ENGRAVE.gold.stroke; }, set: function(v) { A104_ENGRAVE.gold.stroke = v; } });
      it.push({ label: 'Gold Füllung', type: 'text', get: function() { return A104_ENGRAVE.gold.fill; }, set: function(v) { A104_ENGRAVE.gold.fill = v; } });
      it.push({ label: 'Roségold Kontur', type: 'text', get: function() { return A104_ENGRAVE.rosegold.stroke; }, set: function(v) { A104_ENGRAVE.rosegold.stroke = v; } });
      it.push({ label: 'Roségold Füllung', type: 'text', get: function() { return A104_ENGRAVE.rosegold.fill; }, set: function(v) { A104_ENGRAVE.rosegold.fill = v; } });
      it.push({ h: 'Icon · Basis em (Fallback)' });
      it.push({ label: 'Icon Höhe', step: 0.05, get: function() { return A104_ICON.height; }, set: function(v) { A104_ICON.height = v; } });
      it.push({ label: 'Icon ↕ top', step: 0.05, get: function() { return A104_ICON.top; }, set: function(v) { A104_ICON.top = v; } });
      it.push({ label: 'Icon ↔ gap', step: 0.05, get: function() { return A104_ICON.gap; }, set: function(v) { A104_ICON.gap = v; } });
      it.push({ label: 'Icon Opacity (Basis)', step: 0.05, get: function() { return A104_ENGRAVE.iconOpacity; }, set: function(v) { A104_ENGRAVE.iconOpacity = v; } });
      return it;
    }

    function currentSymbolSlug() {
      var d = getSideData(tunerSideIndex());
      return d.symbol ? symbolSlug(d.symbol) : '';
    }

    function contextKey() {
      return tunerSide() + '|' + getGlobalFont().font_name + '|' + currentSymbolSlug();
    }

    function contextItems() {
      var it = [];
      var sk = tunerSide();
      var font = getGlobalFont().font_name;
      function ensureAdj() {
        var s = (A104_TEXT_ADJ[sk] = A104_TEXT_ADJ[sk] || {});
        return (s[font] = s[font] || { mult: 1 });
      }
      function adj() { return (A104_TEXT_ADJ[sk] || {})[font] || {}; }
      function ensurePos() {
        var s = (A104_TEXT_POS[sk] = A104_TEXT_POS[sk] || {});
        return (s[font] = s[font] || { x: A104_TEXT_POS_BASE.x, y: A104_TEXT_POS_BASE.y });
      }
      function posOf() { return (A104_TEXT_POS[sk] || {})[font] || A104_TEXT_POS_BASE; }
      it.push({ h: 'Font: ' + font + ' (' + (sk === 'back' ? 'Rückseite' : 'Vorderseite') + ')' });
      it.push({ label: 'Anker ↔ X %', step: 0.5, get: function() { return posOf().x; }, set: function(v) { ensurePos().x = v; } });
      it.push({ label: 'Anker ↕ Y %', step: 0.5, get: function() { return posOf().y; }, set: function(v) { ensurePos().y = v; } });
      it.push({ label: 'Text-Größe ×', step: 0.02, get: function() { var a = adj(); return a.mult != null ? a.mult : 1; }, set: function(v) { ensureAdj().mult = v; } });
      it.push({ label: 'Breite max %', step: 1, get: function() { var a = adj(); return a.wmax != null ? a.wmax : A104_TEXT_MAX_WIDTH_PCT; }, set: function(v) { ensureAdj().wmax = v; } });
      it.push({ label: 'Höhe max % (0=aus)', step: 0.5, get: function() { var a = adj(); return a.hmax != null ? a.hmax : A104_TEXT_MAX_HEIGHT_PCT; }, set: function(v) { ensureAdj().hmax = v; } });

      function ensureCurve() {
        var s = (A104_CURVE[sk] = A104_CURVE[sk] || {});
        return (s[font] = s[font] || { depth: A104_CURVE_BASE.depth, rotate: A104_CURVE_BASE.rotate, tilt: A104_CURVE_BASE.tilt });
      }
      function curve() { return (A104_CURVE[sk] || {})[font] || A104_CURVE_BASE; }
      it.push({ h: 'Bogen · ' + font + ' (' + (sk === 'back' ? 'Rückseite' : 'Vorderseite') + ')' });
      it.push({ label: 'Bogen Tiefe % (Ränder ↑)', step: 0.2, get: function() { return curve().depth; }, set: function(v) { ensureCurve().depth = v; } });
      it.push({ label: 'Bogen Rotation °', step: 0.5, get: function() { return curve().rotate; }, set: function(v) { ensureCurve().rotate = v; } });
      it.push({ label: 'Neigung ° ganze Zeile (+ links↑)', step: 0.5, get: function() { return curve().tilt || 0; }, set: function(v) { ensureCurve().tilt = v; } });

      function ensureEng() { return (A104_ENGRAVE_ADJ[font] = A104_ENGRAVE_ADJ[font] || {}); }
      function eng() { return A104_ENGRAVE_ADJ[font] || {}; }
      it.push({ h: 'Gravur-Stil · ' + font });
      it.push({ label: 'Kontur-Breite px', step: 0.05, get: function() { var e = eng(); return e.width != null ? e.width : A104_ENGRAVE.width; }, set: function(v) { ensureEng().width = v; } });
      it.push({ label: 'Highlight (text-shadow)', type: 'text', get: function() { var e = eng(); return e.highlight != null ? e.highlight : A104_ENGRAVE.highlight; }, set: function(v) { ensureEng().highlight = v; } });

      var slug = currentSymbolSlug();
      if (slug) {
        function ensureIcon() {
          var f = (A104_ICON_ADJ[font] = A104_ICON_ADJ[font] || {});
          return (f[slug] = f[slug] || {});
        }
        function icon() { return (A104_ICON_ADJ[font] || {})[slug] || {}; }
        it.push({ h: 'Motiv: ' + slug + ' · Font ' + font });
        it.push({ label: 'Icon Höhe (em)', step: 0.05, get: function() { var o = icon(); return o.height != null ? o.height : A104_ICON.height; }, set: function(v) { ensureIcon().height = v; } });
        it.push({ label: 'Icon ↕ top (em)', step: 0.05, get: function() { var o = icon(); return o.top != null ? o.top : A104_ICON.top; }, set: function(v) { ensureIcon().top = v; } });
        it.push({ label: 'Icon ↔ X (em)', step: 0.05, get: function() { var o = icon(); return o.dx != null ? o.dx : (A104_ICON.dx || 0); }, set: function(v) { ensureIcon().dx = v; } });
        it.push({ label: 'Icon ↔ gap/Abstand (em)', step: 0.05, get: function() { var o = icon(); return o.gap != null ? o.gap : A104_ICON.gap; }, set: function(v) { ensureIcon().gap = v; } });
        it.push({ label: 'Icon Winkel °', step: 1, get: function() { var o = icon(); return o.rot != null ? o.rot : (A104_ICON.rot || 0); }, set: function(v) { ensureIcon().rot = v; } });
        it.push({ label: 'Icon Opacity', step: 0.05, get: function() { var o = icon(); return o.opacity != null ? o.opacity : A104_ENGRAVE.iconOpacity; }, set: function(v) { ensureIcon().opacity = v; } });
      }

      // Always-visible per-symbol size list for the CURRENT font — every
      // (font, symbol) height is its own independent value.
      it.push({ h: 'Icon-Größe pro Motiv · ' + font });
      loadSymbols().forEach(function(sym) {
        var symSlug = symbolSlug(sym.text);
        it.push({
          label: sym.text + ' Höhe', step: 0.05,
          get: function() {
            var o = (A104_ICON_ADJ[font] || {})[symSlug] || {};
            return o.height != null ? o.height : A104_ICON.height;
          },
          set: function(v) {
            var f = (A104_ICON_ADJ[font] = A104_ICON_ADJ[font] || {});
            (f[symSlug] = f[symSlug] || {}).height = v;
          }
        });
      });
      return it;
    }

    var el = document.createElement('div');
    el.id = 'a104-tuner';
    el.innerHTML =
      '<div class="kt-title">A104 Tuner</div>' +
      '<div class="kt-side" id="a104-kt-side" style="display:none">' +
        '<button type="button" data-side="front" class="is-active">Vorne</button>' +
        '<button type="button" data-side="back">Hinten</button>' +
      '</div>' +
      '<div id="a104-kt-static"></div>' +
      '<h5 style="color:#c4a574">▼ Kontext (folgt Popup-Auswahl)</h5>' +
      '<div id="a104-kt-context"></div>' +
      '<div class="kt-foot"><textarea readonly></textarea>' +
        '<button type="button" data-a104-copy>Alle Werte anzeigen &amp; kopieren</button></div>';
    document.body.appendChild(el);

    var staticBox = el.querySelector('#a104-kt-static');
    renderInto(staticBox, staticItems());

    var ctxBox = el.querySelector('#a104-kt-context');
    var lastKey = null, lastStaticSide = tunerSide();
    function refresh() {
      var sideTog = el.querySelector('#a104-kt-side');
      if (sideTog) sideTog.style.display = getActiveSideCount() > 1 ? 'flex' : 'none';
      if (tunerSide() !== lastStaticSide) { lastStaticSide = tunerSide(); renderInto(staticBox, staticItems()); }
      var key = contextKey();
      if (key === lastKey) return;
      lastKey = key;
      renderInto(ctxBox, contextItems());
    }
    window.__a104RefreshTuner = refresh;

    el.querySelectorAll('#a104-kt-side button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        window.__a104TunerSide = btn.getAttribute('data-side');
        el.querySelectorAll('#a104-kt-side button').forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        lastKey = null; refresh();
      });
    });

    el.querySelector('[data-a104-copy]').addEventListener('click', function() {
      var ta = el.querySelector('textarea');
      ta.style.display = 'block';
      ta.value = JSON.stringify({
        TEXT_POS: A104_TEXT_POS,
        TEXT_BASE_SIZE: A104_TEXT_BASE_SIZE,
        TEXT_MAX_WIDTH_PCT: A104_TEXT_MAX_WIDTH_PCT,
        TEXT_MAX_HEIGHT_PCT: A104_TEXT_MAX_HEIGHT_PCT,
        TEXT_ADJ: A104_TEXT_ADJ,
        CURVE: A104_CURVE,
        ENGRAVE: A104_ENGRAVE,
        ENGRAVE_ADJ: A104_ENGRAVE_ADJ,
        ICON: A104_ICON,
        ICON_ADJ: A104_ICON_ADJ
      }, null, 1);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
    });

    refresh();
  }

  $(function() {
    buildA104Tuner();
  });
})(jQuery);
